/*
                            _     _
  _____ ____  ____     ____/ |__ (_)__     __ ___
 / ___// __ \/ __ \   / ___|  __|| |\ \   / // _ \
/ /   / /  \ \/  \ \ / /   | |   | | \ \ / // ___/
\ \___\ \__/\ \__/  |\ \___| |__ | |  \ V / \ \___
 \____\\____/\____/_| \____\____\|_|   \_/   \___/

*/

const grey = '#858a93';
const blue = '#00afea';

let coactiveAscii = [
    '                            _     _               \n',
    '  _____ ',  '____  ____   ',       '  ____/ |__ (_)__     __ ___\n',
    ' / ___/',   '/ __ \\/ __ \\  ',    ' / ___|  __|| |\\ \\   / // _ \\\n',
    '/ /   ',    '/ /  \\ \\/  \\ \\ ', '/ /   | |   | | \\ \\ / // ___/\n',
    '\\ \\___',  '\\ \\__/\\ \\__/  |', '\\ \\___| |__ | |  \\ V / \\ \\___\n',
    ' \\____\\', '\\____/\\____/_|',    ' \\____\\____\\|_|   \\_/   \\___/\n',
];
let coactiveAsciiColor = [
    grey,
    grey, blue, grey,
    grey, blue, grey,
    grey, blue, grey,
    grey, blue, grey,
    grey, blue, grey,
];

export default () => {
    console.log(
        coactiveAscii.map(txt => `%c${txt}`).join(''),
        ...coactiveAsciiColor.map(color => `color: ${color}`));
};
